module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-100.6906d86d.eot";